<template>
  <div>
    <el-card
      class="box-card"
      shadow="never"
    >
      <div
        slot="header"
        class="card-header"
      >
        <span>视频管理</span>
        <el-button
          type="primary"
          size="small"
          plain
          @click="videoVisible = true"
        >
          编辑视频
        </el-button>
      </div>
      <div>
        <div
          v-if="video"
          class="video-box"
        >
          <div
            v-if="video"
            class="item"
          >
            <video
              class="video"
              :src="video.image_url"
            />
            <span
              class="detail"
              @click="previewVideo(video.image_url)"
            ><i
              class="icon1 el-icon-zoom-in"
            /></span>
          </div>
        </div>
        <div
          v-else
          class="meter-text"
        >
          请选则视频
        </div>
      </div>
    </el-card>
    <!-- 选择视频 -->
    <SpVideoSelect
      v-model="videoVisible"
      :choose-one="true"
      @chooseVideo="chooseVideo"
    />

    <el-dialog
      width="650px"
      :visible.sync="dialogVisible"
      append-to-body
    >
      <video
        class="preview-video"
        controls
        autoplay
        :src="dialogVideoUrl"
      />
    </el-dialog>
  </div>
</template>

<script>
export default {
  model: {
    prop: 'video',
    event: 'videoChange'
  },
  props: {
    video: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data () {
    return {
      videoVisible: false,
      dialogVisible: false,
      dialogVideoUrl: ''
    }
  },
  methods: {
    // 选择视频
    chooseVideo (selectdata) {
      let video = selectdata[0]
      this.videoVisible = false
      this.$emit('videoChange', video)
    },
    // 视频预览
    previewVideo (item) {
      this.dialogVisible = true
      this.dialogVideoUrl = item
    }
  }
}
</script>

<style lang="scss" scoped>
.video-box {
  overflow: hidden;
  zoom: 1;
  margin-right: -12px;
  .item {
    width: 95px;
    height: 95px;
    float: left;
    margin-right: 8px;
    margin-bottom: 10px;
    position: relative;
    &:last-child {
      margin-right: 0;
    }
    .num {
      position: absolute;
      left: 0;
      top: 0;
      width: 16px;
      height: 16px;
      background: rgba(0, 0, 0, 0.25);
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
    }
    .delete {
      position: absolute;
      right: 0;
      top: 0;
      width: 16px;
      height: 16px;
      background: #1890ff;
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
      cursor: pointer;
      opacity: 0;
    }
    .detail {
      position: absolute;
      left: 50%;
      top: 50%;
      width: 16px;
      height: 16px;
      margin: -8px 0 0 -8px;
      background: #1890ff;
      text-align: center;
      line-height: 16px;
      color: #fff;
      font-size: 12px;
      opacity: 0;
      cursor: pointer;
    }
    .video {
      width: 95px;
      height: 95px;
      background-color: #262626;
    }
    &:hover {
      .delete,
      .detail {
        opacity: 1;
      }
    }
  }
}
.meter-text {
  font-size: 12px;
  color: #999;
  line-height: 20px;
  margin-bottom: 12px;
}

.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

::v-deep {
  .el-card__header {
    padding: 5px 20px;
  }
}
.preview-video {
  width: 100%;
}
.box-card {
  margin-bottom: 20px;
}
</style>
